module.exports = __webpack_public_path__ + "img/filter.bd1f49f2.svg";